export default "__VITE_ASSET__61f01586__"